import { createSlice, isPending } from "@reduxjs/toolkit";
import { GetAllGoalsServices, GetAllPreferencesServices } from "./thunk";

export const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  goals:[],
  preferences:[],
error: "", 
  errorMsg: false, // for error

};


const registerSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {

      // getGoalSuccess(state, action) {
      //   state.goals = action.payload
        
      // },
      apiError(state, action) {
        state.error = action.payload.message;
        state.loading = true;
        state.isUserLogout = false;
        state.errorMsg = true;
      },
      registerUserSuccessful(state, action) {
        state.user = action.payload
        state.loading = false;
        state.errorMsg = false;
      },
     
    
     
      registerUserFailed(state, action) {
        state.user = null;
        state.loading = false;
        state.registrationError = action.payload;
        state.error = true;
      },
      resetRegisterFlagChange(state) {
        state.success = false;
        state.error = false;
      },
      
      reset_register_flag(state) {
        state.error = "";
        state.loading = false;
        state.errorMsg = false;
      }
    },

    extraReducers: (builder) => {
      builder

      // .addCase(changeUserPassword.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      //   state.success = null;
      // })
      // .addCase(changeUserPassword.fulfilled, (state) => {
      //   state.loading = false;
      //   state.success = "Mot de passe changé avec succès";
      // })
      // .addCase(changeUserPassword.rejected, (state, action) => {
      //   console.log("Erreur Redux:", action.payload);
      //   state.loading = false;
      //   state.error = action.payload || "Échec du changement de mot de passe.";
      // })
      
      

        .addCase(GetAllGoalsServices.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(GetAllGoalsServices.fulfilled, (state, action) => {
          state.loading = false;
          state.goals = action.payload.data;
          console.log('gols dans le reducer', state.goals)
        })
        .addCase(GetAllGoalsServices.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.data || 'Erreur inconnue';
        })
      
        .addCase(GetAllPreferencesServices.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(GetAllPreferencesServices.fulfilled, (state, action) => {
          state.loading = false;
          state.preferences = action.payload.data; // Remplace les goals par les données de la requête
        })
        .addCase(GetAllPreferencesServices.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || 'Erreur inconnue';
        });
    },
  });


  export const {
    registerUserSuccessful,
    registerUserFailed,
    resetRegisterFlagChange,
    reset_register_flag,
    getGoalSuccess,
    apiError
  } = registerSlice.actions;
  
  export default registerSlice.reducer;